import React from 'react';
import I18n from '@/modules/i18n';

interface SelectionAnnouncerProps {
  count: number;
}

/**
 * AIDEV-NOTE: mount this unconditionally, alongside the bulk bar rather than inside it. A live region
 * has to be in the accessibility tree *before* its contents change, so a region that appears with the
 * first selection is silently ignored — and 0→1 is the announcement that matters most. See
 * `.claude/docs/patterns-frontend.md` § Live regions. The visible count is aria-hidden so the string
 * isn't heard twice.
 */
const SelectionAnnouncer = ({ count }: SelectionAnnouncerProps) => (
  <span aria-atomic aria-live="polite" className="tw-sr-only" data-testid="selection-announcer">
    {count > 0 ? I18n.t('n_selected', { count }) : ''}
  </span>
);

export default SelectionAnnouncer;
